import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper, Title, Controls } from './ControlBar.style';
import Popover from '../Popover';
import ClientFilter from '../ClientFilter';
import ClientSort from '../ClientSort';

const ControlBar = ({ filters, onFilterChange, sortOption, onSortOptionChange }) => {
  return (
    <Wrapper>
      <Title>All Clients</Title>
      <Controls>
        <Popover title="Filter">
          <ClientFilter filters={filters} onChange={onFilterChange} />
        </Popover>
        <ClientSort value={sortOption} onChange={onSortOptionChange} />
      </Controls>
    </Wrapper>
  );
};

ControlBar.defaultProps = {
  filters: {
    state: 'any',
    app: null,
    companyType: ''
  }
};

ControlBar.propTypes = {
  filters: PropTypes.shape({
    state: PropTypes.string,
    app: PropTypes.string,
    companyType: PropTypes.string
  }),
  onFilterChange: PropTypes.func.isRequired,
  sortOption: PropTypes.string.isRequired,
  onSortOptionChange: PropTypes.func.isRequired
};

export default ControlBar;
